<label
  class="cursor-pointer flex flex-col justify-center"
  [class]="checkBoxValue ? hoverColorClass : ''"
>
  <input
    class="hidden"
    type="checkbox"
    [value]="value"
    [(ngModel)]="checkBoxValue"
    (change)="valueChanged($event)"
  />
  <ng-content select="[checkbox-icon]"></ng-content>
  <ng-content select="[checkbox-text]"></ng-content>
</label>
